import { $t } from '../../composables/i18n'
import CodebookValueNotFoundError from '../CodebookValueNotFoundError'

export enum TerminalOperationTypeId {
  PAYMENT_INSERT_CARD_INTO_TERMINAL = 1,
  PAYMENT_MANUALLY_ENTER_CARD_NUMBER = 2,
  RETURN_INSERT_CARD_INTO_TERMINAL = 3,
  RETURN_MANUALLY_ENTER_CARD_NUMBER = 4,
  PREAUTHORIZATION_INSERT_CARD_INTO_TERMINAL = 5,
  PREAUTHORIZATION_MANUALLY_ENTER_CARD_NUMBER = 6,
  COMPLETE_PREAUTHORIZATION = 7,
  REVERSAL_OF_LAST_TRANSACTION = 8,
  REVERSAL_OF_TRANSACTION = 9,
  AUTOMATICALLY_CHARGED = 10,
}

export enum TerminalOperationTypeCode {
  PAY = 'PAY',
  RETURN = 'RETURN',
  PREAUTH = 'PREAUTH',
  COMPLETION = 'COMPLETION',
  REVERSALLASTPAYMENT = 'REVERSALLASTPAYMENT',
  REVERSAL = 'REVERSAL',
  AUTO = 'AUTO',
}

export class TerminalOperationType {
  static readonly PAYMENT_INSERT_CARD_INTO_TERMINAL = new TerminalOperationType(
    TerminalOperationTypeId.PAYMENT_INSERT_CARD_INTO_TERMINAL,
    $t('Payment - card insertion into terminal'),
    TerminalOperationTypeCode.PAY,
    0,
  )
  static readonly PAYMENT_MANUALLY_ENTER_CARD_NUMBER = new TerminalOperationType(
    TerminalOperationTypeId.PAYMENT_MANUALLY_ENTER_CARD_NUMBER,
    $t('Payment - manual filling in card number'),
    TerminalOperationTypeCode.PAY,
    1,
  )
  static readonly RETURN_INSERT_CARD_INTO_TERMINAL = new TerminalOperationType(
    TerminalOperationTypeId.RETURN_INSERT_CARD_INTO_TERMINAL,
    $t('Return - card insertion into terminal'),
    TerminalOperationTypeCode.RETURN,
    0,
  )
  static readonly RETURN_MANUALLY_ENTER_CARD_NUMBER = new TerminalOperationType(
    TerminalOperationTypeId.RETURN_MANUALLY_ENTER_CARD_NUMBER,
    $t('Return - manual filling in card number'),
    TerminalOperationTypeCode.RETURN,
    1,
  )
  static readonly PREAUTHORIZATION_INSERT_CARD_INTO_TERMINAL = new TerminalOperationType(
    TerminalOperationTypeId.PREAUTHORIZATION_INSERT_CARD_INTO_TERMINAL,
    $t('Preauthorization - card insertion into terminal'),
    TerminalOperationTypeCode.PREAUTH,
    0,
  )
  static readonly PREAUTHORIZATION_MANUALLY_ENTER_CARD_NUMBER = new TerminalOperationType(
    TerminalOperationTypeId.PREAUTHORIZATION_MANUALLY_ENTER_CARD_NUMBER,
    $t('Preauthorization - manual filling in card number'),
    TerminalOperationTypeCode.PREAUTH,
    1,
  )
  static readonly COMPLETE_PREAUTHORIZATION = new TerminalOperationType(
    TerminalOperationTypeId.COMPLETE_PREAUTHORIZATION,
    $t('Preauthorization completion'),
    TerminalOperationTypeCode.COMPLETION,
    null,
  )
  static readonly REVERSAL_OF_LAST_TRANSACTION = new TerminalOperationType(
    TerminalOperationTypeId.REVERSAL_OF_LAST_TRANSACTION,
    $t('Reversal of the last transaction'),
    TerminalOperationTypeCode.REVERSALLASTPAYMENT,
    null,
  )
  static readonly REVERSAL_OF_TRANSACTION = new TerminalOperationType(
    TerminalOperationTypeId.REVERSAL_OF_TRANSACTION,
    $t('Transaction reversal'),
    TerminalOperationTypeCode.REVERSAL,
    null,
  )
  static readonly AUTOMATICALLY_CHARGED = new TerminalOperationType(
    TerminalOperationTypeId.AUTOMATICALLY_CHARGED,
    $t('Automatically charged'),
    TerminalOperationTypeCode.AUTO,
    null,
  )

  private constructor(
    public readonly id: TerminalOperationTypeId,
    public readonly name: string,
    public readonly code: string,
    public readonly manualEntryCard: null | number,
  ) {}

  static getById = (id: TerminalOperationTypeId): TerminalOperationType => {
    const value = TerminalOperationType.all().find((item) => item.id === id)

    if (value === undefined) {
      throw new CodebookValueNotFoundError(TerminalOperationType.name, id)
    }

    return value
  }

  static all = (): TerminalOperationType[] => {
    return [
      TerminalOperationType.PAYMENT_INSERT_CARD_INTO_TERMINAL,
      TerminalOperationType.PAYMENT_MANUALLY_ENTER_CARD_NUMBER,
      TerminalOperationType.RETURN_INSERT_CARD_INTO_TERMINAL,
      TerminalOperationType.RETURN_MANUALLY_ENTER_CARD_NUMBER,
      TerminalOperationType.PREAUTHORIZATION_INSERT_CARD_INTO_TERMINAL,
      TerminalOperationType.PREAUTHORIZATION_MANUALLY_ENTER_CARD_NUMBER,
      TerminalOperationType.COMPLETE_PREAUTHORIZATION,
      TerminalOperationType.REVERSAL_OF_LAST_TRANSACTION,
      TerminalOperationType.REVERSAL_OF_TRANSACTION,
      TerminalOperationType.AUTOMATICALLY_CHARGED,
    ]
  }
}
